import {Box, Stack} from "@mui/material";
import React from "react";
import PerformanceMetrics from "./Utilities/PerformanceMetrics";
import AttributionSummary from "./Utilities/AttributionSummary";
import {Link as RouterLink} from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DateRangeForm from "../../common/DateRangeForm";
import useLocationQueryDateRange from "../../hooks/useLocationQueryDateRange";
import useGetCampaignPerformanceMetrics from "./Utilities/hooks/useGetCampaignPerformanceMetrics";
import useLocationQueryParams from "../../hooks/useLocationQueryParams";
import {objectToQueryString} from "../../../../_helpers";
import useGetCampaignAttributionMetrics from "./Utilities/hooks/useGetCampaignAttributionMetrics";
import moment from "moment";
import {MetricsDetailFooter} from "../MetricsDetail/Sections";

export default function SummaryReport() {
    const { startDate, endDate, setDates } = useLocationQueryDateRange({
        initialStartDate: moment().subtract(2, 'years')
    });
    const { params } = useLocationQueryParams();
    let { campaignIds, organizationId, campaignName, pageFilter,source } = params;
    const payload = {startDate, endDate, campaignId: campaignIds, organizationId}

    const { data, loading } = useGetCampaignPerformanceMetrics(payload)
    const {data: attributionData, loading: attributionLoading} = useGetCampaignAttributionMetrics(payload)

    const summaryReportLink = `/proactive-metrics-details?${objectToQueryString({organizationId, campaignIds, pageFilter, source, campaignName})}`

    return (
        <Box sx={{backgroundColor: '#EDEDE4'}}>
            <Box sx={styles.root}>
                <Box sx={styles.container}>
                    <Box sx={styles.backBtnContainer}>
                        <RouterLink to={summaryReportLink} className="tms-no-underline">
                            <Box sx={styles.backLink}>
                                <Box>
                                    <ArrowBackIosNewIcon sx={styles.arrowBack}/>
                                </Box>
                                <Box mt={'1px'}> Back to Retain Campaigns</Box>
                            </Box>
                        </RouterLink>
                    </Box>
                    <Box>
                        <Stack
                            direction={{ xs: "column", md: "row" }}
                            sx={styles.formContainer}
                            spacing={2}
                        >
                            <Box component={"h1"} sx={styles.heading}>
                                {campaignName}
                            </Box>
                            <Box sx={{ display: "flex", gap: "10px" }}>
                                <DateRangeForm
                                    startDate={startDate}
                                    endDate={endDate}
                                    setDates={setDates}
                                />
                            </Box>
                        </Stack>
                        <PerformanceMetrics data={data} loading={loading} />
                    </Box>

                    <Box mt={{ xs: '30px', sm: '42px'}}>
                        <AttributionSummary data={attributionData} loading={attributionLoading} />
                    </Box>
                </Box>
            </Box>
            <MetricsDetailFooter/>
        </Box>
    );
}

const styles = {
    root: {
        fontFamily: 'FustatMedium',
        letterSpacing: '-0.02em',
        color: '#302E2A',
        backgroundColor: '#edede4',
        pt: 16,
        width: '100%',
        minHeight: '100vh',
    },
    container: {
        maxWidth: '1344px',
        mx: 'auto',
        mt: '-50px',
        height: 'auto',
        position: 'relative',
        background: '#edede4',
        paddingRight: '14px',
        paddingLeft: '14px',
        paddingTop: '28px',
    },
    heading: {
        m: 0,
        fontFamily: 'IvyPrestoHeadlineRegular',
        fontSize: "35px",
        lineHeight: 1.2,
        letterSpacing: "-0.02em",
        color: "#302E2A",
        mb: 2,
        fontWeight: '400',
    },
    headingSmall: {
        fontFamily: 'FustatBold',
        fontSize: '17px',
        letterSpacing: '0.01em'
    },
    backLink:{
        color: '#302E2A',
        position: 'relative',
        fontFamily: 'FustatBold',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'flex-end',
        gap: '20px',
    },
    arrowBack: {
        color: '#003300',
        marginRight:'8px',
        borderRadius: '0px',
        fontSize: '14px',
        position: 'absolute',
        left: '0',
        top: '3px'
    },
    formContainer: {
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", md: "center" },
        mb: { xs: "24px", sm: "40px" },
        mt: { xs: "18px", sm: "24px" }
    },
    backBtnContainer: {
        width: 'fit-content',
        height: 'auto',
        background: '#edede4',
        fontFamily: 'LarsseitRegular !important',
        fontSize: '14px !important',
        fontWeight: '500 !important',
        position: 'relative',
    },
};
